export default {
  en: {
    title: 'If you\'re a parent...',
    subtitle: 'And you don\'t have any children or class bookings registered on your account. And you want to book your children onto a class please ask the club to send you the booking link.',
  },
};
